import { useEffect } from "react"

export const useOnError = (data, callback) => {
  useEffect(() => {
    if (data.isError) {
      callback(data.error)
    }
  }, [data.isError])
}
